

<div class="container1" *ngIf="model == 'creatives'">
  <mat-card appearance="outlined" class="card1">Creatives</mat-card>

  <mat-card appearance="outlined" class="card2 mt-3">
    <div class="section1 ms-3">
      <div class="report-landing">
        <span class="tag_title">select Creatives</span>
        <div class="row creativesTable">
          <div class="creativesTable">
            <div class="creativesHeader">
              <mat-form-field class="ms-2 ">
                <mat-label>Filter</mat-label>
                <input
                  matInput
                  (keyup)="applyCreativesFilter($event)"
                  placeholder="Creatives"
                  #input
                />

              </mat-form-field>
            </div>
            <div class="col-10 mat-elevation-z8">
              <table mat-table [dataSource]="dataSourceCreatives" matSort>
                <ng-container matColumnDef="checkbox">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
                    Select Creatives
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <label class="checkbox-container">
                      <input
                        type="checkbox"
                        (click)="addCreatives(row)"
                      />
                      <span class="checkboxmark"></span>
                    </label>
                  </td>
                </ng-container>
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
                    Id
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.id  }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
                Name
                  </th>
                  <td mat-cell *matCellDef="let row" >
                    {{ row.name }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
               Type
                  </th>
                  <td mat-cell *matCellDef="let row" >
                    {{ row.type }}
                  </td>
                </ng-container>

                <!-- Name Column -->
                <!-- <ng-container matColumnDef="title">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> title </th>
                  <td mat-cell *matCellDef="let row"> {{row.title}} </td>
                </ng-container> -->

                <!-- Color Column -->
                <!-- <ng-container matColumnDef="body">
                  ['checkbox',"id", "short_name"];
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> body </th>
                  <td mat-cell *matCellDef="let row" [style.color]="row.body"> {{row.body}} </td>
                </ng-container> -->

                <tr mat-header-row *matHeaderRowDef="displayedColumnsCreatives"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsCreatives"
                ></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">
                    No data matching the filter "{{ input.value }}"
                  </td>
                </tr>
              </table>

              <mat-paginator
                [pageSizeOptions]="[5, 10, 25, 100]"
              ></mat-paginator>
            </div>
            <!-- <table
              datatable
              [dtOptions]="dtOptions"
              [dtTrigger]="dtTrigger"
              class="row-border hover"
            >
              <thead>
                <tr>
                  <th></th>
                  <th>ID</th>
                  <th class="checkboxes" style="width: 10px">Creatives</th>
                  <th class="checkboxes">Type</th>

                  <th class="checkboxes">Size</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of creatives; let i = index">
                  <td class="checkboxes">
                    <label class="checkbox-container">
                      <input
                        type="checkbox"
                        (click)="addCreatives(item)"
                        [checked]="selectedCreatives.indexOf(item) >= 0"
                      />
                      <span class="checkboxmark"></span>
                    </label>
                  </td>
                  <td>{{ item.advertiser_id }}</td>
                  <td style="width: 10px">{{ item.name }}</td>
                  <td>{{ item.type }}</td>
                  <td></td>
                </tr>
              </tbody>
            </table> -->
          </div>
        </div>
      </div>
    </div>
    <div class="section2 mt-3">
      <div class="right-box">
        <div class="select_creatives">
          <span class="col-5" style="font-size: 15px">Selected Creatives</span>
          <button
            type="button"
            class="btn btn-orng mb-3"
            (click)="removeAllCreatives()"
          >
            Remove All
          </button>
        </div>
        <div class="col-4 mt-2">
          <div class="right-box">
            <div class="selected-segments">
              <!-- <div class="line">
                <span class="col-10" style="font-size: 15px"
                  >Selected Creatives</span
                >
                <button type="button" class="btn btn-orng mb-3">
                  Remove All
                </button>
              </div> -->
              <nav>
                <ul class="list-group mt-4 selected_list_item">
                  <li
                    class="list-group-item"
                    *ngFor="let item of selectedCreatives; let i = index"
                  >
                    <span>{{ item.name }}</span>
                    <span class="float-end action"
                      ><i
                        class="fas fa-times-circle"
                        (click)="removeSelectedCreatives(item)"
                      ></i
                    ></span>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
  <div class="row mt-3 mr-0">
    <div class="col info-text"></div>
    <div class="align-right genreport-btn">
      <button type="button" class="btn btn-orng" (click)="closeCreativesModel($event,false)">
        Cancel
      </button>
    </div>
    <div class="align-right genreport-btn ms-2">
      <button type="button" class="btn btn-orng" (click)="closeCreativesModel($event,true)">
        Save
      </button>
    </div>
  </div>
</div>

<div class="container1" *ngIf="model == 'conversion'">
  <mat-card appearance="outlined" class="card1">Conversion Tracking</mat-card>

  <mat-card appearance="outlined" class="card2 mt-3">
    <div class="section1 ms-3">
      <div class="report-landing">
        <span class="tag_title">Select Conversion</span>
        <div class="row">
          <div class="conversionTable">
            <mat-form-field>
              <mat-label>Filter</mat-label>
              <input
                matInput
                (keyup)="applyConversionFilter($event)"
                placeholder="conversions"
                #input
              />
            </mat-form-field>
            <div class="col-10 mat-elevation-z8">
              <table mat-table [dataSource]="dataSourceConversion" matSort>
                <!-- userId: number,
      id: number,
      title: string,
      body:string -->
                <!-- ID Column -->
                <ng-container matColumnDef="checkbox">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
                    Select  Conversion
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <label class="checkbox-container">
                      <input
                        type="checkbox"
                        (click)="addPixel(row)"
                        [checked]="selectedPixel.indexOf(row) >= 0"
                      />
                      <span class="checkboxmark"></span>
                    </label>
                  </td>
                </ng-container>

                <!--  -->
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
                    Id
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.advertiser_id  }}
                  </td>
                </ng-container>

                <!-- Progress Column -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
                Name
                  </th>
                  <td mat-cell *matCellDef="let row" >
                    {{ row.name }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
               Type
                  </th>
                  <td mat-cell *matCellDef="let row" >
                    {{ row.pixel_type }}
                  </td>
                </ng-container>

                <!-- Name Column -->
                <!-- <ng-container matColumnDef="title">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> title </th>
                  <td mat-cell *matCellDef="let row"> {{row.title}} </td>
                </ng-container> -->

                <!-- Color Column -->
                <!-- <ng-container matColumnDef="body">
                  ['checkbox',"id", "short_name"];
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> body </th>
                  <td mat-cell *matCellDef="let row" [style.color]="row.body"> {{row.body}} </td>
                </ng-container> -->

                <tr mat-header-row *matHeaderRowDef="displayedColumnsConversion"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsConversion"
                ></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">
                    No data matching the filter "{{ input.value }}"
                  </td>
                </tr>
              </table>

              <mat-paginator
                [pageSizeOptions]="[5, 10, 25, 100]"
              ></mat-paginator>
            </div>

     </div>
        </div>
      </div>
    </div>
    <div class="section2 mt-3">
      <div class="right-box">
        <div class="col-10 mt-2">
          <div class="select_title">
            <span class="col-10" style="font-size: 15px"
              >Selected Conversion Pixel</span
            >
            <button
              type="button"
              class="btn btn-orng mb-3"
              (click)="removeAllPixel()"
            >
              Remove All
            </button>
          </div>
          <div class="right-box">
            <div class="selected-segments">
              <nav>
                <ul class="list-group mt-4 selected_list_item">
                  <li
                    class="list-group-item"
                    *ngFor="let item of selectedPixel; let i = index"
                  >
                    <span>{{ item.name }}</span>
                    <span class="float-end action"
                      ><i
                        class="fas fa-times-circle"
                        (click)="removeSelectedPixel(item)"
                      ></i
                    ></span>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
  <div class="row mt-3 mr-0">
    <div class="col info-text"></div>
    <div class="align-right genreport-btn">
      <button type="button" class="btn btn-orng" (click)='closeConversionModel($event,false)'>Cancel</button>
    </div>
    <div class="align-right genreport-btn ms-2">
      <button
        type="button"
        class="btn btn-orng"
        (click)="closeConversionModel($event,true)"
      >
        Save
      </button>
    </div>
  </div>
</div>

<div class="container1" *ngIf="model == 'segment'">
  <mat-card appearance="outlined" class="card1">Add Segments</mat-card>

  <mat-card appearance="outlined" class="card3 mt-3">
    <div class="section1 ms-3">
      <mat-tab-group
        mat-stretch-tabs
        class="example-stretched-tabs mat-elevation-z4"
        [selectedIndex]="slectedTab"
        (selectedIndexChange)="segementView($event)"
      >
        <mat-tab label="My Segment">
          <mat-form-field class="ms-2">
            <mat-label>Filter</mat-label>
            <input
              matInput
              (keyup)=" applyFirstPartyFilter($event)"
              placeholder="Ex. Mia"
              #input
            />
          </mat-form-field>

          <div class="mat-elevation-z8">
            <table mat-table [dataSource]="dataSourceFirstPartySegment" matSort>
              <!-- userId: number,
    id: number,
    title: string,
    body:string -->
              <!-- ID Column -->
              <ng-container matColumnDef="checkbox">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
                  Select Segment
                </th>
                <td mat-cell *matCellDef="let row">
                  <label class="checkbox-container">
                    <input
                      type="checkbox"
                      [checked]="checkIndexOf(row)"
                      (click)="pushFirstPartySegment(row)"
                    />
                    <span class="checkboxmark"></span>
                  </label>
                </td>
              </ng-container>

              <!--  -->
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
                  Id
                </th>
                <td mat-cell *matCellDef="let row">
                  {{ row.id }}
                </td>
              </ng-container>

              <!-- Progress Column -->
              <ng-container matColumnDef="short_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
              Name
                </th>
                <td mat-cell *matCellDef="let row" >
                  {{ row.short_name }}
                </td>
              </ng-container>

              <!-- Name Column -->
              <!-- <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> title </th>
                <td mat-cell *matCellDef="let row"> {{row.title}} </td>
              </ng-container> -->

              <!-- Color Column -->
              <!-- <ng-container matColumnDef="body">
                ['checkbox',"id", "short_name"];
                <th mat-header-cell *matHeaderCellDef mat-sort-header> body </th>
                <td mat-cell *matCellDef="let row" [style.color]="row.body"> {{row.body}} </td>
              </ng-container> -->

              <tr mat-header-row *matHeaderRowDef="displayedColumnsFirstParty"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumnsFirstParty"
              ></tr>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                  No data matching the filter "{{ input.value }}"
                </td>
              </tr>
            </table>

            <mat-paginator
            *ngIf="segmentTab==0"
              [pageSizeOptions]="[5, 10, 25, 100]"
            ></mat-paginator>
          </div>
          <!-- <div class="report-landing">
            <span class="tag_title">Select Segment</span>
            <div class="row">
              <div class="col-12">
                <div class="create-tag-btn">
                  <button
                    type="button"
                    class="btn btn-orng"
                    routerLink="/insertion-order/create"
                  >
                    Select All
                  </button>
                </div>
                <table
                  datatable
                  [dtOptions]="dtOptions"
                  [dtTrigger]="dtTrigger"
                  class="row-border hover"
                >
                  <thead>
                    <tr>
                      <th class="checkboxes"></th>
                      <th class="checkboxes">ID</th>
                      <th class="checkboxes">Name</th>
                      <th class="checkboxes">Type</th>

                      <th class="checkboxes"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of segmentGroup; let i = index">
                      <td class="checkboxes">
                        <label class="checkbox-container">
                          <input
                            type="checkbox"
                            [checked]="checkIndexOf(item)"
                            (click)="pushFirstPartySegment(item)"
                          />
                          <span class="checkboxmark"></span>
                        </label>
                      </td>
                      <td>{{ item.id }}</td>
                      <td>{{ item.short_name }}</td>
                      <td class="checkboxes"></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div> -->
        </mat-tab>
        <mat-tab label="3rd Party Sement">
          <mat-form-field class="ms-2">
            <mat-label>Filter</mat-label>
            <input
              matInput
              (keyup)=" applyThirdPartyFilter($event)"
              placeholder="Ex. Mia"
              #input
            />
          </mat-form-field>

          <div class="mat-elevation-z8">
            <table mat-table [dataSource]="dataSourceThirdPartySegment" matSort>
              <!-- userId: number,
    id: number,
    title: string,
    body:string -->
              <!-- ID Column -->
              <ng-container matColumnDef="checkbox">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
                  Select Segment
                </th>
                <td mat-cell *matCellDef="let row">
                  <label class="checkbox-container">
                    <input
                      type="checkbox"
                      [checked]="checkIndexOf(row)"
                      (click)="pushFirstPartySegment(row)"
                    />
                    <span class="checkboxmark"></span>
                  </label>
                </td>
              </ng-container>

              <!--  -->
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
                  Id
                </th>
                <td mat-cell *matCellDef="let row">
                  {{ row.id }}
                </td>
              </ng-container>

              <!-- Progress Column -->
              <ng-container matColumnDef="short_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
              Name
                </th>
                <td mat-cell *matCellDef="let row" >
                  {{ row.short_name }}
                </td>
              </ng-container>

              <!-- Name Column -->
              <!-- <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> title </th>
                <td mat-cell *matCellDef="let row"> {{row.title}} </td>
              </ng-container> -->

              <!-- Color Column -->
              <!-- <ng-container matColumnDef="body">
                ['checkbox',"id", "short_name"];
                <th mat-header-cell *matHeaderCellDef mat-sort-header> body </th>
                <td mat-cell *matCellDef="let row" [style.color]="row.body"> {{row.body}} </td>
              </ng-container> -->

              <tr mat-header-row *matHeaderRowDef="displayedColumnsThirdParty"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumnsThirdParty"
              ></tr>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                  No data matching the filter "{{ input.value }}"
                </td>
              </tr>
            </table>

            <mat-paginator
            *ngIf="segmentTab==1"
              [pageSizeOptions]="[5, 10, 25, 100]"
            ></mat-paginator>
          </div>
          <!-- <div class="report-landing">
            <span class="tag_title">Select Conversion</span>
            <div class="row">
              <div class="col-12">
                <div class="create-tag-btn">
                  <button
                    type="button"
                    class="btn btn-orng"
                    routerLink="/insertion-order/create"
                  >
                    Select All
                  </button>
                </div>
                <table
                  datatable
                  [dtOptions]="dtOptions"
                  [dtTrigger]="dtTriggerThirdParty"
                  class="row-border hover"
                >
                  <thead>
                    <tr>
                      <th class="checkboxes"></th>
                      <th class="checkboxes">ID</th>
                      <th class="checkboxes">Name</th>
                      <th class="checkboxes">Type</th>

                      <th class="checkboxes"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let item of allThirdPartySegment; let i = index"
                    >
                      <td class="checkboxes">
                        <label class="checkbox-container">
                          <input
                            type="checkbox"
                            [checked]="checkIndexOf(item)"
                            (click)="pushFirstPartySegment(item)"
                          />
                          <span class="checkboxmark"></span>
                        </label>
                      </td>
                      <td>{{ item.id }}</td>
                      <td>{{ item.short_name }}</td>
                      <td class="checkboxes"></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div> -->
        </mat-tab>
      </mat-tab-group>
    </div>

    <div class="section2 mt-3">
      <div class="right-box">
        <div class="col-6 mt-2">
          <div class="line">
            <span class="col-12" style="font-size: 15px"
              >Selected Conversion Pixel</span
            >
            <div class="toggleAndOr">
              <mat-button-toggle-group
                appearance="legacy"
                name="fontStyle"
                aria-label="Font Style"
                [(ngModel)]="segment_boolean_operator"
              >
                <mat-button-toggle value="and">And</mat-button-toggle>
                <mat-button-toggle value="or">Or</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
            <button type="button" class="btn btn-orng mb-3">Remove All</button>
          </div>
          <div class="right-box">
            <div class="selected-segments">
              <div *ngFor="let items of selectedsegmentGroup; let j = index">
                <nav>
                  <ul class="list-group mt-0">
                    <div
                      class="mt-0"
                      *ngIf="j > 0 && segment_boolean_operator == 'and'"
                    >
                      <span class="badge badge-info">AND </span>
                    </div>
                    <div
                      class="mt-0"
                      *ngIf="j > 0 && segment_boolean_operator == 'or'"
                    >
                      <span class="badge badge-info">OR </span>
                    </div>
                    <div
                      class="list-group-item"
                      *ngFor="let item of items; let i = index"
                    >
                      <li>
                        <span class="t"
                          >{{ item.short_name }}{{ item.name }}</span
                        >
                        <span class="float-end action"
                          ><i
                            class="fas fa-times-circle"
                            (click)="removsegment(item)"
                          ></i
                        ></span>
                        <div
                          class="mb-2"
                          *ngIf="i > 0 && segment_boolean_operator == 'or'"
                        >
                          <span class="badge badge-info">AND </span>
                        </div>
                        <div
                          class="mb-2"
                          *ngIf="i > 0 && segment_boolean_operator == 'and'"
                        >
                          <span class="badge badge-info">OR </span>
                        </div>
                      </li>
                    </div>

                    <!-- <li>


                  </li> -->
                  </ul>
                </nav>
              </div>
              <button
                type="button"
                class="btn btn-orng mb-3 mt-3 ms-2"
                (click)="addnewsegmentGroup()"
              >
                + Add New Group
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card>

  <div class="row mt-3 mr-0">
    <div class="col info-text"></div>
    <div class="align-right genreport-btn">
      <button type="button" class="btn btn-orng" (click)="saveSegmentData($event,false)">
        Cancel
      </button>
    </div>
    <div class="align-right genreport-btn ms-2">
      <button type="button" class="btn btn-orng" (click)="saveSegmentData($event,true)">
        Save
      </button>
    </div>
  </div>
</div>

<div class="container1" *ngIf="model == 'targeting'">
  <mat-card appearance="outlined" class="card1">Add Segments</mat-card>

  <div class="container-fluid">
    <mat-tab-group
      [selectedIndex]="selected.value"
      [color]="'warn'"
      (selectedIndexChange)="geoView($event)"
    >
      <mat-tab label="Select Countries">
        <div class="tabView">
          <div class="tabViewer">
            <div class="tabViewer">
              <mat-form-field>
                <mat-label>Filter</mat-label>
                <input
                  matInput
                  (keyup)="applyFilterCountry($event)"
                  placeholder="Ex. India"
                  #input
                />
              </mat-form-field>

              <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSourceCountry" matSort>
                  <!-- userId: number,
      id: number,
      title: string,
      body:string -->
                  <!-- ID Column -->
                  <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
                      Select Country
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <label class="checkbox-container">
                        <input
                          type="checkbox"
                          (click)="addCountrytoSelected(row)"
                          [checked]="countrySelected.indexOf(row) >= 0"
                        />
                        <span class="checkboxmark"></span>
                      </label>
                    </td>
                  </ng-container>

                  <!-- Progress Column -->
                  <ng-container matColumnDef="name">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      style="color: #f1a21d;"
                    >
                      Country Name
                    </th>
                    <td mat-cell *matCellDef="let row" >
                      {{ row.name }}
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                  ></tr>

                  <!-- Row shown when there is no matching data. -->
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">
                      No data matching the filter "{{ input.value }}"
                    </td>
                  </tr>
                </table>

                <mat-paginator
                  *ngIf="tabValue == 0"
                  [pageSizeOptions]="[5, 10, 25, 100]"
                ></mat-paginator>
              </div>
            </div>
            <!-- <div class="tabViewer">
            <div>
                <div class="selected-segments">
                <div>
                    <mat-button-toggle-group
                    appearance="legacy"
                    name="fontStyle"
                    aria-label="Font Style"
                    [(ngModel)]="countryIncludeOrExclude"
                  >
                    <mat-button-toggle value="include">Include</mat-button-toggle>
                    <mat-button-toggle value="exclude">Exclude</mat-button-toggle>
                  </mat-button-toggle-group>
                </div>
                    <div *ngFor="let item of countrySelected">
                        <nav style="border: 1px solid black; display: flex; justify-content: space-between; margin-bottom: 1px;">
                            <span>{{item.name}}</span>
                            <span class="float-end action" (click)="removeSelectedCountry(item)"
                                ><i class="fas fa-times-circle"></i
                            ></span>
                        </nav>
                    </div>
                </div>
            </div>
          </div> -->
            <!-- <table
            datatable
            [dtOptions]="dtOptions"
            [dtTrigger]="dtTrigger"
            class="row-border hover"
          >
            <thead>
              <tr>
                <th class=""></th>
                <th class="">Country</th>
              </tr>
            </thead>
            <tbody>

              <tr *ngFor="let item of allCountry; let i = index">
                <td class="countries">
                  <label class="checkbox-container">
                    <input
                      type="checkbox"
                      (click)="addCountrytoSelected(item)"
                      [checked]="countrySelected.indexOf(item) >= 0"
                    />
                    <span class="checkboxmark"></span>
                  </label>
                  <span class="countries_name ms-5">
                    </span
                  >
                </td>
                <td> {{ item.name }} </td>
              </tr>
            </tbody>
          </table> -->
          </div>
          <div class="tabViewer">
            <div>
              <div class="selected-segments">
                <div>
                  <mat-button-toggle-group
                    appearance="legacy"
                    name="fontStyle"
                    aria-label="Font Style"
                    [(ngModel)]="countryIncludeOrExclude"
                  >
                    <mat-button-toggle value="include"
                      >Include</mat-button-toggle
                    >
                    <mat-button-toggle value="exclude"
                      >Exclude</mat-button-toggle
                    >
                  </mat-button-toggle-group>
                </div>
                <div *ngFor="let item of countrySelected">
                  <nav
                    style="
                      border: 1px solid black;
                      display: flex;
                      justify-content: space-between;
                      margin-bottom: 1px;
                    "
                  >
                    <span>{{ item.name }}</span>
                    <span
                      class="float-end action"
                      (click)="removeSelectedCountry(item)"
                      ><i class="fas fa-times-circle"></i
                    ></span>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Select Regions">
        <div class="tabView">
          <div class="tabViewer">
            <mat-form-field>
              <mat-label>Filter</mat-label>
              <input
                matInput
                (keyup)="applyFilterRegion($event)"
                placeholder="Ex. karnataka"
                #input
              />
            </mat-form-field>

            <div class="mat-elevation-z8">
              <table mat-table [dataSource]="dataSourceRegion" matSort>
                <!-- userId: number,
    id: number,
    title: string,
    body:string -->
                <!-- ID Column -->
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
                    Select region
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <label class="checkbox-container">
                      <input
                        type="checkbox"
                        (click)="addRegiontoSelected(row)"
                        [checked]="countrySelected.indexOf(row) >= 0"
                      />
                      <span class="checkboxmark"></span>
                    </label>
                  </td>
                </ng-container>

                <!-- Progress Column -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
                    Region Name
                  </th>
                  <td mat-cell *matCellDef="let row" >
                    {{ row.name }}
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsRegion"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsRegion"
                ></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">
                    No data matching the filter "{{ input.value }}"
                  </td>
                </tr>
              </table>

              <mat-paginator
                *ngIf="tabValue == 1"
                [pageSizeOptions]="[5, 10, 25, 100]"
              ></mat-paginator>
            </div>
         </div>
          <div class="tabViewer">
            <div>
              <div>
                <div class="selected-segments">
                  <div>
                    <mat-button-toggle-group
                      appearance="legacy"
                      name="fontStyle"
                      aria-label="Font Style"
                      [(ngModel)]="regionIncludeOrExclude"
                    >
                      <mat-button-toggle value="include"
                        >Include</mat-button-toggle
                      >
                      <mat-button-toggle value="exclude"
                        >Exclude</mat-button-toggle
                      >
                    </mat-button-toggle-group>
                  </div>
                </div>
                <div *ngFor="let item of regionSelected">
                  <nav
                    style="
                      border: 1px solid black;
                      display: flex;
                      justify-content: space-between;
                      margin-bottom: 1px;
                    "
                  >
                    <span>{{ item.name }}</span>
                    <span
                      class="float-end action"
                      (click)="removeElementfromlist(regionSelected, item)"
                      ><i class="fas fa-times-circle"></i
                    ></span>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Select City">
        <div class="tabView">
          <div class="tabViewer">
            <mat-form-field>
              <mat-label>Filter</mat-label>
              <input
                matInput
                (keyup)="applyFilterCity($event)"
                placeholder="Ex. Bangalore"
                #input
              />
            </mat-form-field>

            <div class="mat-elevation-z8">
              <table mat-table [dataSource]="dataSourceCity" matSort>
                <!-- userId: number,
      id: number,
      title: string,
      body:string -->
                <!-- ID Column -->
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
                    Select City
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <label class="checkbox-container">
                      <input
                        type="checkbox"
                        (click)="addCitytoSelected(row)"
                        [checked]="countrySelected.indexOf(row) >= 0"
                      />
                      <span class="checkboxmark"></span>
                    </label>
                  </td>
                </ng-container>

                <!-- Progress Column -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
                    City Name
                  </th>
                  <td mat-cell *matCellDef="let row" >
                    {{ row.name }}
                  </td>
                </ng-container>

                <!-- Name Column -->
                <!-- <ng-container matColumnDef="title">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> title </th>
                  <td mat-cell *matCellDef="let row"> {{row.title}} </td>
                </ng-container> -->

                <!-- Color Column -->
                <!-- <ng-container matColumnDef="body">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> body </th>
                  <td mat-cell *matCellDef="let row" [style.color]="row.body"> {{row.body}} </td>
                </ng-container> -->

                <tr mat-header-row *matHeaderRowDef="displayedColumnCity"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnCity"
                ></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">
                    No data matching the filter "{{ input.value }}"
                  </td>
                </tr>
              </table>

              <mat-paginator
                *ngIf="tabValue == 2"
                [pageSizeOptions]="[5, 10, 25, 100]"
              ></mat-paginator>
            </div>
            <!-- <table
              datatable
              [dtOptions]="dtOptions"
              [dtTrigger]="dtTriggercity"
              class="row-border hover"
            >
              <thead>
                <tr>
                  <th class=""></th>
                  <th class="">City</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of allCity; let i = index">
                  <td class="countries">
                    <label class="checkbox-container">
                      <input
                        type="checkbox"
                        (click)="addCitytoSelected(item)"
                        [checked]="countrySelected.indexOf(item) >= 0"
                      />
                      <span class="checkboxmark"></span>
                    </label>
                    <span class="countries_name ms-5">
                      </span
                    >
                  </td>
                  <td> {{ item.name }} </td>
                </tr>
              </tbody>
            </table> -->
          </div>
          <div class="tabViewer">
            <div>
              <div class="selected-segments">
                <div>
                  <mat-button-toggle-group
                    appearance="legacy"
                    name="fontStyle"
                    aria-label="Font Style"
                    [(ngModel)]="cityIncludeOrExclude"
                  >
                    <mat-button-toggle value="include"
                      >Include</mat-button-toggle
                    >
                    <mat-button-toggle value="exclude"
                      >Exclude</mat-button-toggle
                    >
                  </mat-button-toggle-group>
                </div>
                <div *ngFor="let item of citySelected">
                  <nav
                    style="
                      border: 1px solid black;
                      display: flex;
                      justify-content: space-between;
                      margin-bottom: 1px;
                    "
                  >
                    <span>{{ item.name }}</span>
                    <span
                      class="float-end action"
                      (click)="removeElementfromlist(citySelected, item)"
                      ><i class="fas fa-times-circle"></i
                    ></span>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Select DMA">
        <div class="tabView">
          <div class="tabViewer">
            <mat-form-field>
              <mat-label>Filter</mat-label>
              <input
                matInput
                (keyup)="applyFilterDma($event)"
                placeholder="Ex. new york"
                #input
              />
            </mat-form-field>

            <div class="mat-elevation-z8">
              <table mat-table [dataSource]="dataSourceDma" matSort>

                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
                    Select DMA
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <label class="checkbox-container">
                      <input
                        type="checkbox"
                        (click)="addDmaSelected(row)"
                        [checked]="dmaSelected.indexOf(row) >= 0"
                      />
                      <span class="checkboxmark"></span>
                    </label>
                  </td>
                </ng-container>

                <!-- Progress Column -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
                    DMA
                  </th>
                  <td mat-cell *matCellDef="let row" >
                    {{ row.name }}
                  </td>
                </ng-container>

                <!-- Name Column -->
                <!-- <ng-container matColumnDef="title">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> title </th>
                  <td mat-cell *matCellDef="let row"> {{row.title}} </td>
                </ng-container> -->

                <!-- Color Column -->
                <!-- <ng-container matColumnDef="body">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> body </th>
                  <td mat-cell *matCellDef="let row" [style.color]="row.body"> {{row.body}} </td>
                </ng-container> -->

                <tr mat-header-row *matHeaderRowDef="displayedColumnsDma"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsDma"
                ></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">
                    No data matching the filter "{{ input.value }}"
                  </td>
                </tr>
              </table>

              <mat-paginator
                *ngIf="tabValue == 3"
                [pageSizeOptions]="[5, 10, 25, 100]"
              ></mat-paginator>
            </div>
            <!-- <table
              datatable
              [dtOptions]="dtOptions"
              [dtTrigger]="dtTriggerDma"
              class="row-border hover"
            >
              <thead>
                <tr>
                  <th class=""></th>
                  <th class="">DMA</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of allDma; let i = index">
                  <td class="countries">
                    <label class="checkbox-container">
                      <input
                        type="checkbox"
                        (click)="addDmaSelected(item)"
                        [checked]="dmaSelected.indexOf(item) >= 0"
                      />
                      <span class="checkboxmark"></span>
                    </label>
                    <span class="countries_name ms-5"> </span>
                  </td>
                  <td>{{ item.name }}</td>
                </tr>
              </tbody>
            </table> -->
          </div>
          <div class="tabViewer">
            <div>
              <div>
                <!-- Selected DMA -->
                <div class="selected-segments">
                  <div>
                    <mat-button-toggle-group
                      appearance="legacy"
                      name="fontStyle"
                      aria-label="Font Style"
                      [(ngModel)]="dmaIncludeOrExclude"
                    >
                      <mat-button-toggle value="include"
                        >Include</mat-button-toggle
                      >
                      <mat-button-toggle value="exclude"
                        >Exclude</mat-button-toggle
                      >
                    </mat-button-toggle-group>
                  </div>
                </div>
                <div *ngFor="let item of dmaSelected">
                  <nav
                    style="
                      border: 1px solid black;
                      display: flex;
                      justify-content: space-between;
                      margin-bottom: 1px;
                    "
                  >
                    <span>{{ item.name }}</span>
                    <span
                      class="float-end action"
                      (click)="removeElementfromlist(dmaSelected, item)"
                      ><i class="fas fa-times-circle"></i
                    ></span>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Select PostalCodes">
        <div class="tabView">
          <div class="tabViewer">
            <mat-form-field>
              <mat-label>Filter</mat-label>
              <input
                matInput
                (keyup)="applyFilterPostalCodes($event)"
                placeholder="Ex. 00100"
                #input
              />
            </mat-form-field>

            <div class="mat-elevation-z8">
              <table mat-table [dataSource]="dataSourcePostalCodes" matSort>
                <!-- userId: number,
      id: number,
      title: string,
      body:string -->
                <!-- ID Column -->
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;" >
                    SelectPostalCode
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <label class="checkbox-container">
                      <input
                        type="checkbox"
                        (click)="addPostalcodesSelected(row)"
                        [checked]="dmaSelected.indexOf(row) >= 0"
                      />
                      <span class="checkboxmark"></span>
                    </label>
                  </td>
                </ng-container>

                <!-- Progress Column -->
                <ng-container matColumnDef="code">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="color: #f1a21d;">
                    PostalCode
                  </th>
                  <td mat-cell *matCellDef="let row" >
                    {{ row.code }}
                  </td>
                </ng-container>

                <!-- Name Column -->
                <!-- <ng-container matColumnDef="title">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> title </th>
                  <td mat-cell *matCellDef="let row"> {{row.title}} </td>
                </ng-container> -->

                <!-- Color Column -->
                <!-- <ng-container matColumnDef="body">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> body </th>
                  <td mat-cell *matCellDef="let row" [style.color]="row.body"> {{row.body}} </td>
                </ng-container> -->

                <tr mat-header-row *matHeaderRowDef="displayedColumnsPostalCodes"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsPostalCodes"
                ></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">
                    No data matching the filter "{{ input.value }}"
                  </td>
                </tr>
              </table>

              <mat-paginator
                *ngIf="tabValue == 4"
                [pageSizeOptions]="[5, 10, 25, 100]"
              ></mat-paginator>
            </div>
            <!-- <table
              datatable
              [dtOptions]="dtOptions"
              [dtTrigger]="dtTriggerPostalCode"
              class="row-border hover"
            >
              <thead>
                <tr>
                  <th class=""></th>
                  <th class="">PostalCode</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of allPostalCodes; let i = index">
                  <td class="countries">
                    <label class="checkbox-container">
                      <input
                        type="checkbox"
                        (click)="addPostalcodesSelected(item)"
                        [checked]="dmaSelected.indexOf(item) >= 0"
                      />
                      <span class="checkboxmark"></span>
                    </label>
                    <span class="countries_name ms-5"> </span>
                  </td>
                  <td>{{ item.code }}</td>
                </tr>
              </tbody>
            </table> -->
          </div>
          <div class="tabViewer">
            <div>
              <div>
                <div class="selected-segments">
                  <div>
                    <mat-button-toggle-group
                      appearance="legacy"
                      name="fontStyle"
                      aria-label="Font Style"
                      [(ngModel)]="postalcodeIncludeOrExclude"
                    >
                      <mat-button-toggle value="include"
                        >Include</mat-button-toggle
                      >
                      <mat-button-toggle value="exclude"
                        >Exclude</mat-button-toggle
                      >
                    </mat-button-toggle-group>
                  </div>
                </div>
                <div *ngFor="let item of postalCodesSelected">
                  <nav
                    style="
                      border: 1px solid black;
                      display: flex;
                      justify-content: space-between;
                      margin-bottom: 1px;
                    "
                  >
                    <span>{{ item.code }}</span>
                    <span
                      class="float-end action"
                      (click)="removeElementfromlist(postalCodesSelected, item)"
                      ><i class="fas fa-times-circle"></i
                    ></span>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
    <div class="row mt-3 mr-0">
      <div class="col info-text"></div>
      <div class="align-right genreport-btn">
        <button type="button" class="btn btn-orng" (click)="saveGeoData($event,false)">
          Cancel
        </button>
      </div>
      <div class="align-right genreport-btn ms-2">
        <button type="button" class="btn btn-orng" (click)="saveGeoData($event,true)">
          Save
        </button>
      </div>
    </div>
  </div>
  <!-- inventory -->

  <div class="container1" *ngIf="model == 'inventory'">
    <mat-card appearance="outlined" class="card1">Inventory</mat-card>

    <mat-card appearance="outlined" class="card3 mt-3">
      <div class="segment_input ms-3">
        <div class="row">
          <label class="mt-3 label_targeting">Blacklist </label>
          <div class="">
            <div class="mt-3">
              <div class="row row1">
                <div class="checkbox">
                  <label class="title_target ms-2">
                    <i class="far fa-edit ms-2"></i>
                    <!-- <span class="checkboxmark"></span> -->
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <label class="mt-3 label_targeting">WhiteList </label>
          <div class="">
            <div class="">
              <div class="row row1 mt-3">
                <div class="checkbox">
                  <label class="title_target ms-2">
                    <i class="far fa-edit ms-2"></i>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <label class="mt-3 label_targeting">Inventory Safety Segment </label>
          <div class="">
            <div class="">
              <div class="row row1 mt-3">
                <div class="checkbox">
                  <label class="title_target ms-2">
                    <i class="far fa-edit ms-2"></i>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card>

    <div class="row mt-3 mr-0">
      <div class="col info-text"></div>
      <div class="align-right genreport-btn">
        <button type="button" class="btn btn-orng">Cancel</button>
      </div>
      <div class="align-right genreport-btn ms-2">
        <button type="button" class="btn btn-orng">Save</button>
      </div>
    </div>
  </div>
</div>
